import { Route } from "@angular/router";

export const TasksPaths = {
  Start: "start",
  Overview: "overzicht",
  Add: "toevoegen",
  Templates: "sjablonen",
  Interests: "interesses",
  ConfirmInterests: "interesses/bevestigen",
  Invite: "uitnodigen",
  InviteForTask: (taskId: number | string) => `uitnodigen/${taskId}`,
  Invited: "uitgenodigd",
  InvitedPersons: "personen",
  Edit: (taskId: number | string) => `${taskId}`,
};

export default [
  {
    path: "",
    loadComponent: () =>
      import("./pages/search-task/search-task.component").then((c) => c.SearchTaskComponent),
    data: {
      breadcrumb: "Taken",
      title: "Taken",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Start,
    loadComponent: () => import("./pages/start/start.component").then((c) => c.StartComponent),
    data: {
      breadcrumb: "Snel starten",
      title: "Taken en interesses",
    },
  },
  {
    path: TasksPaths.Overview,
    loadComponent: () =>
      import("./pages/search-task/search-task.component").then((c) => c.SearchTaskComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Taken",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Add,
    loadComponent: () =>
      import("./pages/add-task/add-task.component").then((c) => c.AddTaskComponent),
    data: {
      breadcrumb: "Taak toevoegen",
      title: "Taak toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Templates,
    loadComponent: () =>
      import("./pages/search-task/search-task.component").then((c) => c.SearchTaskComponent),
    data: {
      breadcrumb: "Sjablonen beheren",
      title: "Sjablonen voor taken beheren",
      loadTemplates: true,
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Interests,
    loadComponent: () =>
      import("./pages/intrests/intrests.component").then((c) => c.IntrestsComponent),
    data: {
      breadcrumb: "Interesses",
      title: "Interesses",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.ConfirmInterests,
    loadComponent: () =>
      import("./pages/intrests/intrests.component").then((c) => c.IntrestsComponent),
    data: {
      breadcrumb: "Interesses",
      title: "Interesses",
      checkIntrests: true,
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Invite,
    loadComponent: () => import("./pages/invite/invite.component").then((c) => c.InviteComponent),
    data: {
      breadcrumb: "Uitnodigen en werven",
      title: "Kandidaten uitnodigen en werven",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.InviteForTask(":id"),
    loadComponent: () => import("./pages/invite/invite.component").then((c) => c.InviteComponent),
    data: {
      breadcrumb: "Uitnodigen en werven",
      title: "Kandidaten uitnodigen en werven",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Invited,
    loadComponent: () =>
      import("./components/task-invited/task-invited.component").then(
        (c) => c.TaskInvitedComponent
      ),
    data: {
      breadcrumb: "Uitgenodigd",
      title: "Kandidaten uitgenodigd",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.InvitedPersons,
    loadComponent: () =>
      import("./pages/search-task-person/search-task-person.component").then(
        (c) => c.SearchTaskPersonComponent
      ),
    data: {
      breadcrumb: "Uitgenodigde kandidaten",
      title: "Uitgenodigde kandidaten",
      subscriptionTypes: [1],
    },
  },
  {
    path: TasksPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/add-task/add-task.component").then((c) => c.AddTaskComponent),
    data: {
      breadcrumb: "Taak bewerken",
      title: "Taak bewerken",
      subscriptionTypes: [1],
    },
  },
] satisfies Route[];
